import Menu from '@lucide/svelte/icons/menu';
import Copy from '@lucide/svelte/icons/copy';
import House from '@lucide/svelte/icons/house';
import User from '@lucide/svelte/icons/user';
import UserPlus from '@lucide/svelte/icons/user-plus';
import Mail from '@lucide/svelte/icons/mail';
import MailPlus from '@lucide/svelte/icons/mail-plus';
import Star from '@lucide/svelte/icons/star';
import CirclePlus from '@lucide/svelte/icons/circle-plus';
import Compass from '@lucide/svelte/icons/compass';
import Smile from '@lucide/svelte/icons/smile';
import SmilePlus from '@lucide/svelte/icons/smile-plus';
import Leaf from '@lucide/svelte/icons/leaf';
import Sticker from '@lucide/svelte/icons/sticker';
import Trash2 from '@lucide/svelte/icons/trash-2';
import Phone from '@lucide/svelte/icons/phone';
import PhoneOff from '@lucide/svelte/icons/phone-off';
import Headphones from '@lucide/svelte/icons/headphones';
import HeadphoneOff from '@lucide/svelte/icons/headphone-off';
import Send from '@lucide/svelte/icons/send';
import Bell from '@lucide/svelte/icons/bell';
import BellRing from '@lucide/svelte/icons/bell-ring';
import BellDot from '@lucide/svelte/icons/bell-dot';
import BellOff from '@lucide/svelte/icons/bell-off';
import MessageSquare from '@lucide/svelte/icons/message-square';
import MessageSquareDot from '@lucide/svelte/icons/message-square-dot';
import Settings from '@lucide/svelte/icons/settings';
import Search from '@lucide/svelte/icons/search';
import Heart from '@lucide/svelte/icons/heart';
import Play from '@lucide/svelte/icons/play';
import Pause from '@lucide/svelte/icons/pause';
import Sun from '@lucide/svelte/icons/sun';
import Image from '@lucide/svelte/icons/image';
import LockKeyhole from '@lucide/svelte/icons/lock-keyhole';
import Clapperboard from '@lucide/svelte/icons/clapperboard';
import Flag from '@lucide/svelte/icons/flag';
import Volleyball from '@lucide/svelte/icons/volleyball';
import Lightbulb from '@lucide/svelte/icons/lightbulb';
import Terminal from '@lucide/svelte/icons/terminal';
import Pencil from '@lucide/svelte/icons/pencil';
import Info from '@lucide/svelte/icons/info';
import Shield from '@lucide/svelte/icons/shield';
import ShieldCheck from '@lucide/svelte/icons/shield-check';
import ShieldUser from '@lucide/svelte/icons/shield-user';
import Coffee from '@lucide/svelte/icons/coffee';
import Pin from '@lucide/svelte/icons/pin';
import Volume2 from '@lucide/svelte/icons/volume-2';
import VolumeX from '@lucide/svelte/icons/volume-x';
import File from '@lucide/svelte/icons/file';
import LayoutGrid from '@lucide/svelte/icons/layout-grid';
import Hand from '@lucide/svelte/icons/hand';
import Eye from '@lucide/svelte/icons/eye';
import EyeOff from '@lucide/svelte/icons/eye-off';
import TriangleAlert from '@lucide/svelte/icons/triangle-alert';
import Funnel from '@lucide/svelte/icons/funnel';
import Bookmark from '@lucide/svelte/icons/bookmark';
import Inbox from '@lucide/svelte/icons/inbox';
import MessagesSquare from '@lucide/svelte/icons/messages-square';
import MessageSquarePlus from '@lucide/svelte/icons/message-square-plus';
import Reply from '@lucide/svelte/icons/reply';
import Monitor from '@lucide/svelte/icons/monitor';
import ScreenShare from '@lucide/svelte/icons/screen-share';
import Server from '@lucide/svelte/icons/server';
import Ban from '@lucide/svelte/icons/ban';
import CircleMinus from '@lucide/svelte/icons/circle-minus';
import Mic from '@lucide/svelte/icons/mic';
import MicOff from '@lucide/svelte/icons/mic-off';
import Video from '@lucide/svelte/icons/video';
import VideoOff from '@lucide/svelte/icons/video-off';
import Quote from '@lucide/svelte/icons/quote';
import Hash from '@lucide/svelte/icons/hash';
import Layers from '@lucide/svelte/icons/layers';
import ChevronRight from '@lucide/svelte/icons/chevron-right';
import ChevronLeft from '@lucide/svelte/icons/chevron-left';
import ChevronUp from '@lucide/svelte/icons/chevron-up';
import ChevronDown from '@lucide/svelte/icons/chevron-down';
import Plus from '@lucide/svelte/icons/plus';
import Minus from '@lucide/svelte/icons/minus';
import X from '@lucide/svelte/icons/x';
import EllipsisVertical from '@lucide/svelte/icons/ellipsis-vertical';
import Ellipsis from '@lucide/svelte/icons/ellipsis';
import Check from '@lucide/svelte/icons/check';
import CheckCheck from '@lucide/svelte/icons/check-check';
import Download from '@lucide/svelte/icons/download';
import ExternalLink from '@lucide/svelte/icons/external-link';
import Clock from '@lucide/svelte/icons/clock';
import History from '@lucide/svelte/icons/history';
import Power from '@lucide/svelte/icons/power';
import LogIn from '@lucide/svelte/icons/log-in';
import LogOut from '@lucide/svelte/icons/log-out';
import FileDown from '@lucide/svelte/icons/file-down';
import Paperclip from '@lucide/svelte/icons/paperclip';
import ALargeSmall from '@lucide/svelte/icons/a-large-small';
import Baseline from '@lucide/svelte/icons/baseline';
import Text from '@lucide/svelte/icons/text';
import Heading1 from '@lucide/svelte/icons/heading-1';
import Heading2 from '@lucide/svelte/icons/heading-2';
import Heading3 from '@lucide/svelte/icons/heading-3';
import Bold from '@lucide/svelte/icons/bold';
import Italic from '@lucide/svelte/icons/italic';
import Underline from '@lucide/svelte/icons/underline';
import Strikethrough from '@lucide/svelte/icons/strikethrough';
import Link from '@lucide/svelte/icons/link';
import Code from '@lucide/svelte/icons/code';
import SquareCode from '@lucide/svelte/icons/square-code';
import ListOrdered from '@lucide/svelte/icons/list-ordered';
import List from '@lucide/svelte/icons/list';
import AtSign from '@lucide/svelte/icons/at-sign';
import ListFilter from '@lucide/svelte/icons/list-filter';
import ListRestart from '@lucide/svelte/icons/list-restart';
import ArrowUpDown from '@lucide/svelte/icons/arrow-up-down';
import ArrowRight from '@lucide/svelte/icons/arrow-right';
import ArrowLeft from '@lucide/svelte/icons/arrow-left';
import ArrowUp from '@lucide/svelte/icons/arrow-up';
import ArrowDown from '@lucide/svelte/icons/arrow-down';
import RefreshCw from '@lucide/svelte/icons/refresh-cw';
import Globe from '@lucide/svelte/icons/globe';

export type IconSrc = { icon: typeof House; badge?: typeof House };

export const Icons = {
	Copy: { icon: Copy },
	Home: { icon: House },
	User: { icon: User },
	UserPlus: { icon: UserPlus },
	Mail: { icon: Mail },
	MailPlus: { icon: MailPlus },
	Star: { icon: Star },
	PlusCircle: { icon: CirclePlus },
	Explore: { icon: Compass },
	Smile: { icon: Smile },
	SmilePlus: { icon: SmilePlus },
	Leaf: { icon: Leaf },
	Sticker: { icon: Sticker },
	Delete: { icon: Trash2 },
	Phone: { icon: Phone },
	PhoneDown: { icon: PhoneOff },
	Headphone: { icon: Headphones },
	HeadphoneMute: { icon: HeadphoneOff },
	Send: { icon: Send },
	Bell: { icon: Bell },
	BellRing: { icon: BellRing },
	BellPing: { icon: BellDot },
	BellMute: { icon: BellOff },
	Message: { icon: MessageSquare },
	MessageUnread: { icon: MessageSquareDot },
	Setting: { icon: Settings },
	Search: { icon: Search },
	Heart: { icon: Heart },
	Play: { icon: Play },
	Pause: { icon: Pause },
	Sun: { icon: Sun },
	Photo: { icon: Image },
	Lock: { icon: LockKeyhole },
	Vlc: { icon: Clapperboard },
	Flag: { icon: Flag },
	Ball: { icon: Volleyball },
	Bulb: { icon: Lightbulb },
	Terminal: { icon: Terminal },
	Pencil: { icon: Pencil },
	Info: { icon: Info },
	Shield: { icon: Shield },
	ShieldLock: { icon: ShieldCheck },
	ShieldUser: { icon: ShieldUser },
	Cup: { icon: Coffee },
	Pin: { icon: Pin },
	VolumeHigh: { icon: Volume2 },
	VolumeHighLock: { icon: Volume2, badge: LockKeyhole },
	VolumeHighGlobe: { icon: Volume2, badge: Globe },
	VolumeMute: { icon: VolumeX },
	File: { icon: File },
	Category: { icon: LayoutGrid },
	Peace: { icon: Hand },
	Eye: { icon: Eye },
	EyeBlind: { icon: EyeOff },
	Warning: { icon: TriangleAlert },
	Funnel: { icon: Funnel },
	Bookmark: { icon: Bookmark },
	Inbox: { icon: Inbox },
	Thread: { icon: MessagesSquare },
	ThreadPlus: { icon: MessageSquarePlus },
	ThreadUnread: { icon: MessagesSquare, badge: BellDot },
	ThreadReply: { icon: MessagesSquare, badge: Reply },
	Monitor: { icon: Monitor },
	ScreenShare: { icon: ScreenShare },
	Server: { icon: Server },
	Prohibited: { icon: Ban },
	NoEntry: { icon: CircleMinus },
	Mic: { icon: Mic },
	MicMute: { icon: MicOff },
	VideoCamera: { icon: Video },
	VideoCameraMute: { icon: VideoOff },
	BlockQuote: { icon: Quote },
	Hash: { icon: Hash },
	HashLock: { icon: Hash, badge: LockKeyhole },
	HashGlobe: { icon: Hash, badge: Globe },
	HashSearch: { icon: Hash, badge: Search },
	HashPlus: { icon: Hash, badge: Plus },
	Space: { icon: Layers },
	SpaceLock: { icon: Layers, badge: LockKeyhole },
	SpaceGlobe: { icon: Layers, badge: Globe },
	SpaceSearch: { icon: Layers, badge: Search },
	SpacePlus: { icon: Layers, badge: Plus },
	ChevronRight: { icon: ChevronRight },
	ChevronLeft: { icon: ChevronLeft },
	ChevronTop: { icon: ChevronUp },
	ChevronBottom: { icon: ChevronDown },
	Plus: { icon: Plus },
	Minus: { icon: Minus },
	Cross: { icon: X },
	VerticalDots: { icon: EllipsisVertical },
	HorizontalDots: { icon: Ellipsis },
	Menu: { icon: Menu },
	Check: { icon: Check },
	CheckTwice: { icon: CheckCheck },
	Download: { icon: Download },
	External: { icon: ExternalLink },
	Clock: { icon: Clock },
	RecentClock: { icon: History },
	Power: { icon: Power },
	ReplyArrow: { icon: Reply },
	ArrowGoRight: { icon: LogIn },
	ArrowGoRightPlus: { icon: LogIn, badge: Plus },
	ArrowGoRightCross: { icon: LogIn, badge: X },
	ArrowGoLeft: { icon: LogOut },
	Markdown: { icon: FileDown },
	Attachment: { icon: Paperclip },
	Alphabet: { icon: ALargeSmall },
	AlphabetUnderline: { icon: Baseline },
	Text: { icon: Text },
	Heading1: { icon: Heading1 },
	Heading2: { icon: Heading2 },
	Heading3: { icon: Heading3 },
	Bold: { icon: Bold },
	Italic: { icon: Italic },
	Underline: { icon: Underline },
	Strike: { icon: Strikethrough },
	Link: { icon: Link },
	Code: { icon: Code },
	BlockCode: { icon: SquareCode },
	OrderList: { icon: ListOrdered },
	UnorderList: { icon: List },
	Mention: { icon: AtSign },
	Filter: { icon: ListFilter },
	Sort: { icon: ListRestart },
	ArrowUpDown: { icon: ArrowUpDown },
	ArrowRight: { icon: ArrowRight },
	ArrowLeft: { icon: ArrowLeft },
	ArrowTop: { icon: ArrowUp },
	ArrowBottom: { icon: ArrowDown },
	ArrowDropRight: { icon: ChevronRight },
	ArrowDropLeft: { icon: ChevronLeft },
	ArrowDropTop: { icon: ChevronUp },
	ArrowDropBottom: { icon: ChevronDown },
	Reload: { icon: RefreshCw },
	Globe: { icon: Globe }
} satisfies Record<string, IconSrc>;

export type IconName = keyof typeof Icons;
